import { useEffect, useState } from "react";

const modes = ["system", "dark", "light"];
const labels = {
  system: "Как на устройстве",
  dark: "Тёмная тема",
  light: "Светлая тема",
};

const ThemeToggle = () => {
  const [mode, setMode] = useState(() => document.documentElement.dataset.theme || "system");
  const [deviceDark, setDeviceDark] = useState(() => window.matchMedia("(prefers-color-scheme: dark)").matches);

  useEffect(() => {
    const preference = window.matchMedia("(prefers-color-scheme: dark)");
    const updateDevice = () => setDeviceDark(preference.matches);
    const syncStorage = (event) => {
      if (event.key === "theme" || event.key === null) {
        setMode(modes.includes(event.newValue) ? event.newValue : "system");
      }
    };
    updateDevice();
    preference.addEventListener("change", updateDevice);
    window.addEventListener("storage", syncStorage);
    return () => {
      preference.removeEventListener("change", updateDevice);
      window.removeEventListener("storage", syncStorage);
    };
  }, []);

  useEffect(() => {
    if (mode === "system") delete document.documentElement.dataset.theme;
    else document.documentElement.dataset.theme = mode;
    const dark = mode === "dark" || (mode === "system" && deviceDark);
    document.querySelector('meta[name="theme-color"]').setAttribute("content", dark ? "#181818" : "#ffffff");
  }, [mode, deviceDark]);

  const nextMode = modes[(modes.indexOf(mode) + 1) % modes.length];
  const changeTheme = () => {
    setMode(nextMode);
    try {
      if (nextMode === "system") window.localStorage.removeItem("theme");
      else window.localStorage.setItem("theme", nextMode);
    } catch {
      // Switching still works when the browser blocks persistent storage.
    }
  };

  return (
    <button className="theme-toggle" type="button" onClick={changeTheme}
      aria-label={`Тема: ${labels[mode]}. Переключить: ${labels[nextMode]}`}
      title={`${labels[mode]}. Переключить: ${labels[nextMode]}`}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {mode === "system" ? <><rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8m-4-4v4" /></>
          : mode === "dark" ? <path d="M20.5 13a8.5 8.5 0 0 1-9.5-9.5A8.5 8.5 0 1 0 20.5 13Z" />
          : <><circle cx="12" cy="12" r="4" /><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" /></>}
      </svg>
      <span className="theme-toggle-label">{labels[mode]}</span>
    </button>
  );
};

export default ThemeToggle;
